var render = function render(_c,_vm){return _c('button',{staticClass:"cs-button",class:`cs-button__${_vm.props.buttonType}`,attrs:{"type":"button","disabled":_vm.props.disabled,"id":_vm.props.id},on:{"click":_vm.listeners.click}},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_c('div',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }